import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textFormat',
    standalone: true
})
export class TextFormatPipe implements PipeTransform {
    urlPattern = /(http|ftp|https):(\/)*[\w-]+(\.[\w-]+)+([\w.,@$!*?^=%&amp;:\/~+#-]*)?/gi;

    transform(input: string): string {
        if (!input) {
            return '';
        }

        return input
            .replace(/\n/g, '<br>')
            .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
            .replace(this.urlPattern, '<a target="_blank" href="$&" rel="noopener">$&</a>');
    }
}
